import React, { useState, memo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { CurrentValue } from './CurrentValue'
import { Editing } from './Editing'
import { Icon } from './Icon'
import { Label } from './Label'
import { INPUT_ID } from './constants'

export const InlineEdit = memo(
  ({
    autocomplete,
    companyId,
    editable,
    handleUserChange,
    hideLabel,
    id: inputId,
    label,
    maxLength,
    type,
    userId,
    value,
  }) => {
    const [editing, setEditing] = useState(false)
    const [currentValue, setCurrentValue] = useState(value)
    useEffect(() => {
      setCurrentValue(value)
    }, [value])

    let originalValue

    if (!originalValue && value) {
      originalValue = value
    }

    const cancelEdit = () => {
      if (originalValue) setCurrentValue(originalValue)
    }

    const clickHandler = () => {
      if (editing) cancelEdit()
      setEditing(!editing)
    }

    return (
      <span className='toggle-on-hover'>
        <span>
          <Label id={INPUT_ID} text={label} hideLabel={hideLabel} />
          <div className='dib inline-edit'>
            <div className='ph1'>
              {editing ? (
                <Editing
                  autocomplete={autocomplete}
                  companyId={companyId}
                  inputId={inputId}
                  type={type}
                  value={currentValue}
                  setValue={setCurrentValue}
                  handleUserChange={handleUserChange}
                  clickHandler={clickHandler}
                  maxLength={maxLength}
                />
              ) : (
                <CurrentValue autocomplete={autocomplete} userId={userId} value={currentValue} />
              )}
            </div>
          </div>
          {editable && <Icon editing={editing} clickHandler={clickHandler} />}
        </span>
      </span>
    )
  }
)

InlineEdit.propTypes = {
  handleUserChange: PropTypes.func,
  autocomplete: PropTypes.bool,
  id: PropTypes.string,
  userId: PropTypes.number,
  companyId: PropTypes.number,
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  editable: PropTypes.bool,
  hideLabel: PropTypes.bool,
  maxLength: PropTypes.string,
}
InlineEdit.defaultProps = {
  handleUserChange: () => {},
  autocomplete: false,
  id: '',
  userId: null,
  companyId: null,
  label: '',
  type: '',
  value: '',
  editable: false,
  hideLabel: false,
  maxLength: '',
}
